import React from 'react'
import { Link } from 'react-router-dom'
import { SiteContainer, Flex, FlexItem } from 'core/layout'
import { Close } from 'core/icons'
import tulkojumi from 'utils/tulkojumi'
import { getCookieValue, setCookieValue } from 'utils/cookies'
import { Paragraph, Button } from 'elements'
import { StyledInfo } from './styled'

class CookieInfo extends React.PureComponent {
  state = {
    hideCookieInfo: true
  };

  componentDidMount() {
    const hideCookieInfo = getCookieValue('hideCookieInfo', false)
    if (this.state.hideCookieInfo !== hideCookieInfo) {
      document.body.classList.add('js-cookie-info-shown')
      this.setState(prevState => Object.assign(prevState, {}, {
        hideCookieInfo
      }), () => {
        const {
          hideCookieInfo
        } = this.state

        if (!hideCookieInfo) {
          this.forceUpdate()
        }
      })
    }
  }

  componentDidUpdate() {
    const { onUpdateState } = this.props
    onUpdateState && onUpdateState()
  }

  _onClose = () => {
    setCookieValue('hideCookieInfo', true)
    this.setState(prevState => Object.assign(prevState, {}, {
      hideCookieInfo: true
    }), () => {
      document.body.classList.remove('js-cookie-info-shown')
      window.dispatchEvent(new Event('resize'))
      this.forceUpdate()
    })
  }

  render() {
    const {
      hideCookieInfo
    } = this.state

    if (hideCookieInfo) {
      return null
    }

    const {
      useOfCookiesPage,
      disagreementToUseOfCookiesPage,
      teksti
    } = this.props

    return (
      <StyledInfo data-query-id='js-cookie-info'>
        <SiteContainer>
          <Flex>
            <FlexItem>
              <Paragraph>
                {`${tulkojumi(teksti, 'izmantojot_so_lapu_jus_piekritat_sikdatnu_izmantosanai')}.`}
            </Paragraph>
              <Paragraph>
                {`${tulkojumi(teksti, 'sikdatnes_palidz_uzlabot_pakalpojumu_kvalitati')}. `}
                { useOfCookiesPage ? (
                <Link to={useOfCookiesPage.path || '/#'}>
                  {`${tulkojumi(teksti, 'uzzinat_vairak')}.`}
                </Link>
                ) : null}
              </Paragraph>
            </FlexItem>
            <FlexItem>
              <Button
                type='text'
                label={tulkojumi(teksti, 'piekritu')}
                iconSize='large'
                a11yLabel={tulkojumi(teksti, 'piekritu')}
                onClick={() => {
                  this._onClose()
                }} />
              <Button
                href={disagreementToUseOfCookiesPage.path || '/#'}
                type='text'
                label={tulkojumi(teksti, 'nepiekritu')}
                iconSize='large'
                a11yLabel={tulkojumi(teksti, 'nepiekritu')} />
            </FlexItem>
          </Flex>
        </SiteContainer>
      </StyledInfo>
    )
  }
}

export default CookieInfo



// WEBPACK FOOTER //
// ./src/modules/CookieInfo/CookieInfo.jsx